module.exports = __webpack_public_path__ + "img/discover.cca350f4.svg";